import React, { useRef, useState, useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import Button from '../components/Button'
import ImageVideoSlider from '../components/ImageVideoSlider'
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

const ImageBeforeAfter = ({ module, beforeImage, afterImage, title, shortTitle, description, buttons, equalCol, imagePosition, sectionColor, faqData, showFaq = false, bgGray = false, sectionId }) => {

    const [showAfter, setShowAfter] = useState(false);

    const frameRef = useRef(null);

    const updatePosition = (clientX) => {
        if (!containerRef.current) return;

        const rect = containerRef.current.getBoundingClientRect();

        let x = clientX - rect.left;
        let percent = (x / rect.width) * 100;

        percent = Math.max(0, Math.min(100, percent));

        if (frameRef.current) {
            cancelAnimationFrame(frameRef.current);
        }

        frameRef.current = requestAnimationFrame(() => {
            setSliderPosition(percent);
        });
    };

    const containerRef = useRef(null);

    const [sliderPosition, setSliderPosition] = useState(50);
    const [isDragging, setIsDragging] = useState(false);

    // Mouse Move
    useEffect(() => {
        // const handleMove = (e) => {
        //     if (!isDragging || !containerRef.current) return;

        //     const rect = containerRef.current.getBoundingClientRect();

        //     let x = e.clientX - rect.left;
        //     let percent = (x / rect.width) * 100;

        //     percent = Math.max(0, Math.min(100, percent));

        //     setSliderPosition(percent);
        // };

        // const handleTouchMove = (e) => {
        //     if (!isDragging || !containerRef.current) return;

        //     const rect = containerRef.current.getBoundingClientRect();

        //     let x = e.touches[0].clientX - rect.left;
        //     let percent = (x / rect.width) * 100;

        //     percent = Math.max(0, Math.min(100, percent));

        //     setSliderPosition(percent);
        // };

        const handleMove = (e) => {
            if (!isDragging) return;
            updatePosition(e.clientX);
        };

        const handleTouchMove = (e) => {
            if (!isDragging) return;
            updatePosition(e.touches[0].clientX);
        };

        const stopDragging = () => {
            setIsDragging(false);
        };

        window.addEventListener("mousemove", handleMove);
        window.addEventListener("mouseup", stopDragging);

        window.addEventListener("touchmove", handleTouchMove);
        window.addEventListener("touchend", stopDragging);

        return () => {
            window.removeEventListener("mousemove", handleMove);
            window.removeEventListener("mouseup", stopDragging);

            window.removeEventListener("touchmove", handleTouchMove);
            window.removeEventListener("touchend", stopDragging);
        };
    }, [isDragging]);


    const mergeConsecutiveLists = (content) => {
        if (!Array.isArray(content)) return content;

        const merged = [];

        content.forEach((block) => {
            const lastBlock = merged[merged.length - 1];

            // Merge consecutive unordered lists
            if (
                block?.type === "list" &&
                lastBlock?.type === "list" &&
                block?.format === lastBlock?.format
            ) {
                lastBlock.children = [
                    ...(lastBlock.children || []),
                    ...(block.children || []),
                ];
            } else {
                merged.push({ ...block });
            }
        });

        return merged;
    };


    return (
        <section className={`before-after-sec pt-pb-10 ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} sec-${sectionColor}-color ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`} id={sectionId}>
            <div className='container'>
                <div className={`row ${imagePosition === 'Rechts' ? 'flex-lg-row-reverse' : ''}`}>
                    <div className={`${equalCol === "Ja" ? 'col-lg-6' : 'col-lg-5'} image-col position-relative`}>
                        <div className="before-after-wrapper" ref={containerRef}>

                            <img
                                src={`https://backend.bgzurlinden.ch${beforeImage?.url}`}
                                alt="Before"
                                className="before-img d-flex"
                            />

                            {/* BEFORE IMAGE */}
                            {/* <div
                                className="before-image-wrapper"
                                style={{
                                    // width: `${100 - sliderPosition}%`,
                                    width: '100%'
                                }}
                            >
                                <img
                                    src={`https://backend.bgzurlinden.ch${beforeImage?.url}`}
                                    alt="Before"
                                />
                            </div> */}

                            {/* AFTER IMAGE */}
                            <div
                                className="after-image-wrapper"
                                style={{
                                    // width: `${sliderPosition}%`,
                                    width: '100%',
                                    clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`,
                                }}
                            >
                                <img
                                    src={`https://backend.bgzurlinden.ch${afterImage?.url}`}
                                    alt="After"
                                    className="after-img"
                                />
                            </div>

                            {/* CENTER LINE + HANDLE */}
                            <div
                                className="slider-line"
                                style={{
                                    left: `${sliderPosition}%`,
                                }}
                            >
                                <button
                                    type="button"
                                    className="slider-handle"
                                    onMouseDown={() => setIsDragging(true)}
                                    onTouchStart={() => setIsDragging(true)}
                                >
                                    <img
                                        src="https://backend.bgzurlinden.ch/uploads/Group_1597881217_3f0cbe8c59.svg"
                                        alt=""
                                    />
                                </button>
                            </div>

                        </div>
                    </div>
                    <div className={`${equalCol === "Ja" ? 'col-lg-6' : 'col-lg-7'} content-col mt-3 mt-lg-0 align-self-center tick_list`}>
                        {shortTitle && <div className='subtitle'>{shortTitle}</div>}
                        {title && <h2 className='text-black mb-2'>{title}</h2>}
                        {description && (
                            <BlocksRenderer content={mergeConsecutiveLists(description)} />
                        )}
                        {showFaq &&
                            <div className="accordion accordion-sec-wrapper" id="faqAccordion">
                                {showFaq && (
                                    <div className="accordion accordion-sec-wrapper" id="faqAccordion">
                                        {faqData.map((item, index) => (
                                            <div className="accordion-item" key={item.id}>
                                                <div className="accordion-header">
                                                    <button
                                                        className="accordion-button collapsed fs_24"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse-${item.id}`}
                                                        aria-expanded="false"
                                                        aria-controls={`collapse-${item.id}`}
                                                    >
                                                        {item?.Titel}
                                                    </button>
                                                </div>

                                                <div
                                                    id={`collapse-${item.id}`}
                                                    className="accordion-collapse collapse"
                                                    data-bs-parent="#faqAccordion"
                                                >
                                                    <div className="accordion-body">
                                                        {/* <p>{item.Text}</p> */}
                                                        {item?.Text && <BlocksRenderer content={item?.Text} />}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>}
                        <Button buttons={buttons} btnStyle="round_btn" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ImageBeforeAfter